































































import {
  Vue,
  Component,
  Ref,
  PropSync,
  Prop,
  Watch
} from 'vue-property-decorator'
import { RawLocation } from 'vue-router'

export interface TabItem {
  name: string
  slot: string
  color?: string
  backgroundHighlight?: boolean
  glitch?: boolean
  to?: RawLocation | null
  disabled?: boolean
  icon?: string
  order?: number
  mobileOrder?: number
}

@Component
export default class OverlayTabs extends Vue {
  @PropSync('tab', { required: true })
  currentTab!: number

  @Prop({ required: true })
  readonly items!: TabItem[]

  @Prop({ type: Boolean, default: false }) readonly small!: boolean
  @Prop({ type: Boolean, default: false }) readonly secondary!: boolean

  windowTab: number = 0
  isPopupVisible: boolean = false
  windowTransition: boolean | undefined = false
  mobileFabButtonSize: number = 26
  mobileFabIconSize: number = 16

  @Ref('container')
  readonly container!: HTMLDivElement

  @Watch('isPopupVisible')
  onPopupVisibleChange(newVal: boolean) {
    if (newVal) {
      setTimeout(() => (this.windowTransition = undefined), 100)
    } else {
      this.windowTransition = false
      this.currentTab = 0
    }
  }

  @Watch('currentTab')
  onCurrentTabChanged(newVal: number) {
    if (this.isPopupVisible) {
      this.windowTab = newVal
    }
  }

  get activeClass(): string {
    if (this.secondary) {
      return 'active secondary'
    }
    return 'active'
  }

  get expandablePanelIndex(): number {
    return this.isPopupVisible ? 0 : -1
  }

  get currentWindow(): string {
    const item = this.items[this.windowTab - 1]

    if (!item) {
      return ''
    }

    return item.slot
  }

  get tabsHeight() {
    if (this.small) {
      return '2rem'
    }
    return '3.75rem'
  }

  mounted() {
    document.documentElement.addEventListener('click', this.onClickOutside)
  }

  beforeDestroy() {
    document.documentElement.removeEventListener('click', this.onClickOutside)
  }

  onClickOutside(e: MouseEvent) {
    const children = this.container.getElementsByTagName('*')

    for (const child of children) {
      if (child === e.target) {
        return
      }
    }

    this.isPopupVisible = false
    this.$emit('close')
  }

  onClickInside(item: TabItem) {
    if (!item.to) {
      if (this.isPopupVisible && this.currentWindow === item.slot) {
        this.isPopupVisible = false
        this.$emit('close')
      } else {
        this.isPopupVisible = true
        this.$emit('select', item)
      }
    } else {
      this.$emit('select', item.to)
    }
  }
}
